define(['client/resourceinfo', 'client/sourceinfo-debug', 'underscore'], function(ResInfo, SourceInfo, _) {
  var isProductionMode = false;
  try {
    isProductionMode = process.env.NODE_ENV === "production";
  } catch (e) {}

  if (_.isEmpty(SourceInfo) || isProductionMode) {

    return {
      builtinSources: [ ResInfo.scriptLocation + '../../api/v2/' ]
    };
  }

  return SourceInfo;
});
